<template lang="">
	<div class="row position-relative overflow-hidden p-3 bg-light">
		<div class="col-md-6 p-lg-5 my-auto">
			<h1 class="display-4 fw-normal mb-4">Permission denied!</h1>
			<p class="lead fw-normal">The object that you are trying to edit either doesn't exist or you do not have permission to edit it.</p>
		</div>
		<div class="col-md-6 p-5 text-center">
			<img src="/images/404.svg" alt="" srcset="" height="450px">
		</div>
	</div>
</template>
<script>
	export default {};
</script>
